<div class="tw-min-w-fit tw-min-h-fit tw-pr-6 tw-pb-10 sm:tw-pr-32 sm:tw-pb-32">
    <div class="room-boundary" >
        <ng-content></ng-content>
    </div>
</div>
